export const AUTHENTICATION_URL = process.env.REACT_APP_AUTHENTICATION_URL;
export const INVOICE_MANAGEMENT_URL =
  process.env.REACT_APP_INVOICE_MANAGEMENT_URL;
export const USER_MANAGEMENT_URL = process.env.REACT_APP_USER_MANAGEMENT_URL;
export const APP_URL = process.env.REACT_APP_BASE_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const DOCUMENT_SERVICE_URL = process.env.REACT_APP_DOCUMENT_SERVICE_URL;
export const LOCAL_STORAGE_SECRET_KEY =
  process.env.REACT_APP_LOCAL_STORAGE_SECRET_KEY;

export const GOOGLE_DRIVE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_DRIVE_CLIENT_ID;
export const GOOGLE_DRIVE_API_KEY = process.env.REACT_APP_GOOGLE_DRIVE_API_KEY;
export const GOOGLE_DRIVE_SECRET_KEY =
  process.env.REACT_APP_GOOGLE_DRIVE_SECRET_KEY;

export const QB_CLIENT_ID = process.env.REACT_APP_QB_CLIENT_ID;

export const ONE_DRIVE_AZURE_TENANT_ID =
  process.env.REACT_APP_ONE_DRIVE_AZURE_TENANT_ID;
export const ONE_DRIVE_AZURE_CLIENT_ID =
  process.env.REACT_APP_ONE_DRIVE_AZURE_CLIENT_ID;

export const THIRD_PARTY_REDIRECT_URL_URL_FOR_AUTOMATED =
  process.env.REACT_APP_THIRD_PARTY_REDIRECT_URL_FOR_AUTOMATED;
export const THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_INVOICES =
  process.env.REACT_APP_THIRD_PARTY_REDIRECT_URL_FOR_MANUAL_INVOICES;
export const THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_SALES =
  process.env.REACT_APP_THIRD_PARTY_REDIRECT_URL_FOR_MANUAL_SALES;
export const THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_RECEIPT =
  process.env.REACT_APP_THIRD_PARTY_REDIRECT_URL_FOR_MANUAL_RECEIPTS;

export const THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_SETTINGS =
  process.env.REACT_APP_THIRD_PARTY_REDIRECT_URL_FOR_MANUAL_SETTINGS;

export const API = {
  ALL_FLOWS: `${APP_URL}/nodeKafka/invoice-config/getAllConfigFlows`,
  DASHBOARD_FLOWS: `${APP_URL}/nodeKafka/invoice-config/dashboardFlows`,
  EDIT_FLOW: `${APP_URL}/nodeKafka/invoice-config/editFlow`,
  ADD_FLOW: `${APP_URL}/nodeKafka/invoice-config/addFlow`,
  UPDATE_TIMESTAMP: `${APP_URL}/nodeKafka/invoice-config/updateTime`,
  UPDATE_DETAILS: `${APP_URL}/nodeKafka/invoice-config/updateDetail`,
  CREATE_LOGS: `${APP_URL}/nodeKafka/invoice-config/createLogs`,
  DELETE_FLOW: `${APP_URL}/nodeKafka/invoice-config/deleteFlow`,
  DELETE_MULTIPLE_FLOW: `${APP_URL}/nodeKafka/invoice-config/deleteMultipleFlows`,
  SINGLE_FLOW: `${APP_URL}/nodeKafka/invoice-config/getFlowById`,
  SINGLE_FLOW_LOGS: `${APP_URL}/nodeKafka/invoice-config/getLogsById`,
  RENAME_FLOW: `${APP_URL}/nodeKafka/invoice-config/renameFlowName`,
  ODOOAUTH_FLOW: `${APP_URL}/nodeKafka/export/odooAuth`,
  SEND_AUTH_CODE_OF_QB: `${DOCUMENT_SERVICE_URL}/export/sendAuthCodeOfQB`,
  ODOO_EXPORT: `${DOCUMENT_SERVICE_URL}/export/odoo/odooExportManual`,
  GET_TAXES: `${DOCUMENT_SERVICE_URL}/export/commonExport/getAllTaxes`,
  CREATE_TOKEN: `${APP_URL}/nodeKafka/invoice-config/createToken`,
  GET_USER_FROM_CREDENTIAL: `${APP_URL}/nodeKafka/invoice-config/getAllUserFromCredential`,
  DELETE_USER_FROM_CREDENTIAL: `${APP_URL}/nodeKafka/invoice-config/deleteCredential`,
  MICROSOFT_UPLOAD: `${APP_URL}/nodeKafka/invoice-config/microSoftUploadFlow`,
  GOOGLE_UPLOAD: `${APP_URL}/nodeKafka/invoice-config/googleUploadFlow`,
  MICROSOFT_AUTH_FLOW: `${APP_URL}/nodeKafka/microsoft-auth-import/microsoftAuth`,
  MICROSOFT_AUTH_FLOW_CALLBACK: `${APP_URL}/nodeKafka/microsoft-auth-import/microsoftAuth/callback`,
  XERO_AUTH_FLOW: `${APP_URL}/nodeKafka/xero-auth-export/xeroAuth`,
  XERO_AUTH_FLOW_CALLBACK: `${APP_URL}/nodeKafka/xero-auth-export/xeroAuth/callback`,
  ZOHOAUTH_FLOW: `${APP_URL}/nodeKafka/export/zohoAuth`,
  ZOHOAUTH_FLOW_CALLBACK: `${APP_URL}/nodeKafka/export/zohoAuth/callback`,
  QB_AUTH_FLOW_CALLBACK: `${APP_URL}/nodeKafka/export/quickBooksAuth/callback`,
  XERO_EXPORT: `${DOCUMENT_SERVICE_URL}/export/xero/xeroExportManual`,

  ZOHO_EXPORT: `${DOCUMENT_SERVICE_URL}/export/zoho/zohoExportManual`,
  TALLY_EXPORT: `${DOCUMENT_SERVICE_URL}/export/tally/tallyPrimeExportManual`,
  QUICK_BOOK_MANUAL_EXPORT: `${DOCUMENT_SERVICE_URL}/export/quickBook/quickBookManualExport`,
  MANUAL_AUTH_CREDENTIAL: `${APP_URL}/nodeKafka/export/credentialEntryForManual`,
  UPDATE_CREDENTIAL: `${APP_URL}/nodeKafka/export/updatedCredential`,
  GENERATE_API_KEY: `${USER_MANAGEMENT_URL}/users/generate-api-key`,
  UPDATE_CLIENT_NAME: `${USER_MANAGEMENT_URL}/users/update/client-name`,
  REGENERATE_SECRET_KEY: `${USER_MANAGEMENT_URL}/users/update/secret-key`,
  API_KEY_LIST: `${USER_MANAGEMENT_URL}/users/all-api-keys`,
  CREDENTIALS_LIST: `${USER_MANAGEMENT_URL}/users/get-Credentials`,
  CREDENTIALS_BY_ID: `${USER_MANAGEMENT_URL}/users/get-CredentialsById`,
  DELETE_CREDENTIAL: `${USER_MANAGEMENT_URL}/users/delete-Credentials`,
  ADMIN_ACTIVITY_HISTORY: `${USER_MANAGEMENT_URL}/users/admin-activity-history`,
  GET_SECRET_KEY: `${USER_MANAGEMENT_URL}/users/get-secret-key`,
  CHANGE_DOWNLOAD_STATUS: `${USER_MANAGEMENT_URL}/users/update-download-status`,
  DELETE_KEY: `${USER_MANAGEMENT_URL}/users/delete-key`,

  CHANGE_TFA_STATUS: `${USER_MANAGEMENT_URL}/users/tfa`,
  VERIFICATION_STATUS: `${AUTHENTICATION_URL}/auth/verify-tfa-otp`,
  RESEND_OTP: `${AUTHENTICATION_URL}/auth/generate-tfa-otp`,

  ALL_NOTIFICATION: `${APP_URL}/nodeKafka/api/notifications`,
  DELETE_NOTIFICATION: `${APP_URL}/nodeKafka/api/deleteNotification`,
  READ_NOTIFICATION: `${APP_URL}/nodeKafka/api/notification`,
  READ_ALL_NOTIFICATIONS: `${APP_URL}/nodeKafka/api/all-notification`,
  UPLOAD_DOCUMENT: `${APP_URL}/nodeKafka/api/upload`,
  UPLOAD_DOCUMENT_MICROSOFT_MANUAL: `${APP_URL}/nodeKafka/api/upload/microsoftManual`,
  UPLOAD_DOCUMENT_GOOGLE_MANUAL: `${APP_URL}/nodeKafka/api/upload/googleManual`,
  INVITE_USER: `${USER_MANAGEMENT_URL}/users/invite`,
  UPDATE_USER: `${USER_MANAGEMENT_URL}/users/update/user-detail`,
  INVITE_ROOT_ADMIN: `${USER_MANAGEMENT_URL}/users/invite-root-admin`,
  INVITE_NEW_MEMBERS_SA_SIDE: `${USER_MANAGEMENT_URL}/users/invite/sa-new-members`,
  ORGANIZATION_DATA: `${USER_MANAGEMENT_URL}/users`,
  SALES_ORGANIZATION_DATA: `${USER_MANAGEMENT_URL}/users/user-sales-admin`,
  INVITED_SUBSCRIBER: `${USER_MANAGEMENT_URL}/users/invited-subscriber`,
  SUPER_MANAGER_DATA: `${USER_MANAGEMENT_URL}/users/get-super-manager`,
  PAYMENT_HISTORY_DATA: `${USER_MANAGEMENT_URL}/users/payments`,
  DELETE_PAYMENT: `${USER_MANAGEMENT_URL}/users/payment/delete`,
  ALL_ORGANIZATIONS_DATA: `${USER_MANAGEMENT_URL}/users/organizations`,
  ADD_PAYMENT_DETAILS: `${USER_MANAGEMENT_URL}/users/payment`,
  ADD_CREDIT_DETAILS: `${USER_MANAGEMENT_URL}/users/credit/add`,
  ADD_SALES_TEAM_CREDIT: `${USER_MANAGEMENT_URL}/users/add/sales-team-credit`,
  GET_CHECKBOX_DATA_FIELDS: `${USER_MANAGEMENT_URL}/users/data-field-status`,
  GET_CHECKED_DATA_FIELDS: `${USER_MANAGEMENT_URL}/users/data-fields`,
  POST_CHECKBOX_DATA_FIELDS: `${USER_MANAGEMENT_URL}/users/created`,
  SELECT_ALL_CHECKBOX_DATA_FIELDS: `${USER_MANAGEMENT_URL}/users/all/created`,
  ANNOTATION_DOC: `${APP_URL}/nodeKafka/annotation`,
  GENERATE_OTP: `${AUTHENTICATION_URL}/auth/generate-otp`,
  VERIFY_OTP: `${AUTHENTICATION_URL}/auth/verify-otp`,
  RESET_PASSWORD: `${AUTHENTICATION_URL}/auth/reset-password`,
  CHANGE_PASSWORD: `${AUTHENTICATION_URL}/auth/change-password`,
  REGISTER_USER: `${USER_MANAGEMENT_URL}/users/register`,
  LOGIN_USER: `${AUTHENTICATION_URL}/auth/signin`,
  LOGOUT_USER: `${AUTHENTICATION_URL}/auth/logout`,
  REFRESH_TOKEN: `${AUTHENTICATION_URL}/auth/refreshtoken`,
  LOGGED_USER: `${USER_MANAGEMENT_URL}/users/me`,
  GET_MEMBERS: `${USER_MANAGEMENT_URL}/users`,
  VERIFY_TOKEN: `${USER_MANAGEMENT_URL}/users/invite/verify`,
  VERIFY_ROOT_ADMIN_TOKEN: `${USER_MANAGEMENT_URL}/users/invite/verify-root-admin`,
  ADD_USER: `${USER_MANAGEMENT_URL}/users/invite/update`,
  GET_COUNTRIES: `${USER_MANAGEMENT_URL}/users/countries`,
  GET_SALES_ADMIN_LIST: `${USER_MANAGEMENT_URL}/users/sales-admins`,
  ACTIVATE_MEMBER: `${USER_MANAGEMENT_URL}/users/active`,
  GET_ALL_SUBSCRIPTION_PLAN: `${USER_MANAGEMENT_URL}/users/pricing-plan/all`,
  ADD_SUBSCRIPTION_PLAN: `${USER_MANAGEMENT_URL}/users/pricing-plan/add`,
  DELETE_SUBSCRIPTION_PLAN: `${USER_MANAGEMENT_URL}/users/pricing-plan/delete`,
  DISCONTINUE_SUBSCRIPTION_PLAN: `${USER_MANAGEMENT_URL}/users/pricing-plan/discontinue`,
  UPDATE_SUBSCRIPTION_PLAN: `${USER_MANAGEMENT_URL}/users/pricing-plan/update`,
  DOWNLOAD_DOCUMENT: `${USER_MANAGEMENT_URL}/users/export-invoice`,
  UPDATE_DOCUMENT_DUPLICATE: `${USER_MANAGEMENT_URL}/users/updateDocumentDuplicate`,
  UPDATE_MANAGER_FC_STATUS: `${USER_MANAGEMENT_URL}/users/update-fc-status`,
  UPDATE_DOCUMENT_DUPLICATE_DETAILS: `${USER_MANAGEMENT_URL}/users/updateDocumentDetailsDuplicate`,
  USER_BY_ID: `${USER_MANAGEMENT_URL}/users`,
  FILTER_SORT_PAYMENT_DATA: `${USER_MANAGEMENT_URL}/users/payments`,
  PENDING_INPROGRESS_DOCUEMENTS: `${INVOICE_MANAGEMENT_URL}/invoice/pendingInprogress`,
  GET_ROW_DATA: `${INVOICE_MANAGEMENT_URL}/invoice/documents`,
  SORT_ROW_DATA: `${INVOICE_MANAGEMENT_URL}/invoice/documents`,
  SEARCHED_DATA: `${INVOICE_MANAGEMENT_URL}/invoice/search`,
  UPLOAD_CONTROLLER: `${DOCUMENT_SERVICE_URL}/img-server/images/`,
  DELETE_DOCUMENT: `${DOCUMENT_SERVICE_URL}/img/remove`,
  EXPORT_DOCUMENT: `${DOCUMENT_SERVICE_URL}/img/export`,
  EXPORT_JSON: `${DOCUMENT_SERVICE_URL}/img/exportJSON`,
  EXPORT_JSON_FROM_GRID_ACTION: `${DOCUMENT_SERVICE_URL}/img/exportJSONFromGridAction`,
  EXPORT_XML_FROM_GRID_ACTION: `${DOCUMENT_SERVICE_URL}/img/exportXMLFromGridAction`,
  ADD_IMPORT_EXPORT_DETAILS_TO_DOCUMENT_SUMMARY: `${DOCUMENT_SERVICE_URL}/img/addImportExportDetailsToDocumentSummary`,
  EXPORT_XLSX_FROM_GRID_ACTION: `${DOCUMENT_SERVICE_URL}/img/exportXLSXFromGridAction`,
  EXPORT_XML: `${DOCUMENT_SERVICE_URL}/img/exportXML`,
  EXPORT_XLSX: `${DOCUMENT_SERVICE_URL}/img/exportXLSX`,
  DOWNLOAD_EXCEL: `${DOCUMENT_SERVICE_URL}/img/download-xlsx`,
  GET_TAG_DATA: `${INVOICE_MANAGEMENT_URL}/invoice/tag`,
  ADD_TAG_DATA: `${INVOICE_MANAGEMENT_URL}/invoice/tag`,
  ASSOCIATE_TAG: `${INVOICE_MANAGEMENT_URL}/invoice/tag/document`,
  FILTER_TAG: `${INVOICE_MANAGEMENT_URL}/invoice/tag`,
  REMOVE_ASSOCIATE_TAG: `${INVOICE_MANAGEMENT_URL}/invoice/delete/tag/document`,
  ASSOCIATE_TAG_TO_SELECTED_DOCUMENTS: `${INVOICE_MANAGEMENT_URL}/invoice/tag/all`,
  DELETE_ASSOCIATE_TAG_TO_SELECTED_DOCUMENTS: `${INVOICE_MANAGEMENT_URL}/invoice/deleteTag/selected`,
  RENAME_DOCUMENT: `${INVOICE_MANAGEMENT_URL}/invoice/rename`,
  GET_DOCUMENT: `${INVOICE_MANAGEMENT_URL}/invoice/documents`,
  GET_ALL_VERSION: `${APP_URL}/nodeKafka/annotation/getAllVersion`,
  RENAME_VERSION: `${APP_URL}/nodeKafka/annotation/renameVersionName`,
  DELETE_VERSION: `${APP_URL}/nodeKafka/annotation/deleteVersion`,
  GET_VERSION_ANNOTATION: `${APP_URL}/nodeKafka/annotation/getVersion`,
  ADD_VERSION_ANNOTATION: `${APP_URL}/nodeKafka/annotation/addVersion`,
  SPECIFIC_VERSION_VALIDATE: `${APP_URL}/nodeKafka/annotation/edit/version`,
  EXTRACT_API: `${APP_URL}/nodeKafka/annotation/extract-text`,
  GET_INVOICE_COLUMN: `${INVOICE_MANAGEMENT_URL}/invoice/grid`,
  INVOICE_COLUMN: `${INVOICE_MANAGEMENT_URL}/invoice/grid-setting`,
  CURRENCY_CONVERTED_DATA: `${APP_URL}/nodeKafka/annotation/currency-converter`,
  GET_CREDIT_HISTORY_DATA: `${USER_MANAGEMENT_URL}/users/get-credit-history`,
  GET_SCAN_HISTORY_DATA: `${INVOICE_MANAGEMENT_URL}/invoice/scan-history`,
  GET_EXPORT_REPORT_DATA: `${INVOICE_MANAGEMENT_URL}/invoice/export-report`,
  GET_ORGANIZATION_PAYMENT_HISTORY: `${INVOICE_MANAGEMENT_URL}/invoice/organization-payment-history`,
  GET_ORGANIZATION_PLANS: `${INVOICE_MANAGEMENT_URL}/invoice/organization-plans`,
  GET_ACTIVITY_LOGS: `${INVOICE_MANAGEMENT_URL}/activity-logs/allActivityLogs`,
  GET_SCAN_HISTORY_DATA_SA: `${INVOICE_MANAGEMENT_URL}/invoice/all/scan-history`,
  GET_SCAN_HISTORY_CHART_DATA: `${INVOICE_MANAGEMENT_URL}/invoice/graph-data`,
  ALL_ORGANIZATION_SCAN_HISTORY_CHART_DATA: `${INVOICE_MANAGEMENT_URL}/invoice/scan-graph-data`,
  ACTIVITY_HISTORY: `${USER_MANAGEMENT_URL}/users/activity-history`,
  ROOT_ADMIN_ACTIVITY_HISTORY: `${USER_MANAGEMENT_URL}/users/root-admin-activity-history`,
  DELETE_ALL_DOCUMENT: `${DOCUMENT_SERVICE_URL}/img/delete`,
  EXPORT__DOCUMENT_TO_EXCEL: `${DOCUMENT_SERVICE_URL}/img/exportToExcel`,
  EXPORT_DOCUMENT_TO_JSON: `${DOCUMENT_SERVICE_URL}/img/exportToJSON`,
  EXPORT_DOCUMENT_TO_XML: `${DOCUMENT_SERVICE_URL}/img/exportToXML`,
  MODEL_SELECT_DROPBOX: `${APP_URL}/nodeKafka/kafka/getModels`,
  GET_SELECTED_MODEL: `${APP_URL}/nodeKafka/kafka/getModel`,
  POST_SELECTED_MODEL: `${APP_URL}/nodeKafka/kafka/postModel`,
  GET_SELECTED_MODEL_FOR_SA: `${APP_URL}/nodeKafka/kafka/getModelForSA`,
  POST_SELECTED_MODEL_FOR_SA: `${APP_URL}/nodeKafka/kafka/postModelForSA`,
  GET_STAGE: `${INVOICE_MANAGEMENT_URL}/invoice/stage`,
  DELETE_USER: `${USER_MANAGEMENT_URL}/users/delete`,
  ADMIN_DETAILS: `${USER_MANAGEMENT_URL}/users/admin-details`,
  GET_SUBSCRIPTION_DETAILS: `${USER_MANAGEMENT_URL}/users/organization/subscriptions`,
  CREATE_OR_UPDATE_SUBSCRIPTION_DETAILS: `${USER_MANAGEMENT_URL}/users/organization/subscription`,
  GET_ALL_PRICING_PLAN_DETAILS: `${USER_MANAGEMENT_URL}/users/pricing-plan/all`,
  GET_PRICING_PLAN_DETAILS: `${USER_MANAGEMENT_URL}/users/pricing-plan`,
  GET_ORGANIZATION_NUMBER: `${USER_MANAGEMENT_URL}/users/get-organizations-status`,
  TAG_EDIT_DELETE: `${INVOICE_MANAGEMENT_URL}/invoice/tag`,
  GET_ORGANIZATIONS: `${USER_MANAGEMENT_URL}/users/get-organizations`,
  ADD_UPDATE_BILLING_INFO: `${USER_MANAGEMENT_URL}/users/billing-info`,
  GET_MANAGERS: `${USER_MANAGEMENT_URL}/users/managers`,
  SEND_METRICS_DATA: `${APP_URL}/analytics`,
  GET_DOCUMENT_STATUS: `${INVOICE_MANAGEMENT_URL}/invoice/getDocumentStatus`,
  GET_TOTAL_VALIDATED_DOCUMENTS: `${INVOICE_MANAGEMENT_URL}/invoice/getTotalValidatedDocuments`,
  GET_USER_STATISTICS: `${INVOICE_MANAGEMENT_URL}/invoice/getUserStatistics`,
  GET_FLOW_STATISTICS: `${INVOICE_MANAGEMENT_URL}/invoice/getFlowStatistics`,
  GET_CREDITS_INFO: `${INVOICE_MANAGEMENT_URL}/invoice/getCreditsInfo`,
  GET_IMPORT_EXPORT_STATISTICS: `${INVOICE_MANAGEMENT_URL}/invoice/getImportExportStatistics`,
  GET_GOOGLE_TOKEN: `${APP_URL}/nodeKafka/api/get-google-tokens`,
};
